import React from 'react'
import { Col, Row, Button } from 'react-bootstrap'
import styled from 'styled-components'

const PrintableRow = styled(Row)`
  @media print {
    .btn.btn-success,
    .btn.btn-danger {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }
`

const InLineVariantDisplay = ({
  lastSelectedVariant,
  setOpenVariantModal,
  article,
}) => {
  let firstSelected = null
  let secondSelected = null

  if (lastSelectedVariant) {
    if ((lastSelectedVariant.separatedDisplayName || []).length) {
      firstSelected = lastSelectedVariant.separatedDisplayName[0]
      secondSelected = lastSelectedVariant.separatedDisplayName[1] || null
    } else {
      firstSelected = lastSelectedVariant.displayName
    }
  }

  return (
    <PrintableRow>
      <Col>
        <Button
          className='w-100'
          onClick={() => setOpenVariantModal(article)}
          size='sm'
          variant={firstSelected ? 'success' : 'danger'}
        >
          {firstSelected || '-'}
        </Button>
      </Col>
      {secondSelected ? (
        <Col>
          <Button
            className='w-100'
            onClick={() => setOpenVariantModal(article)}
            size='sm'
            variant='success'
          >
            {secondSelected}
          </Button>
        </Col>
      ) : null}
    </PrintableRow>
  )
}

export default InLineVariantDisplay
